module.exports = __webpack_public_path__ + "static/FairfestLogo-16aaf4848e46654969dd19a145ec8ca6.png";